/* PrivateRoute.tsx
   Version: 1.0.0
   Date: 2020-12-10
*/

// eslint-disable-next-line
import React from 'react';
import { Redirect, RouteProps } from 'react-router-dom';
import { CompatRoute } from 'react-router-dom-v5-compat';
import { AppContext } from '../AppContext';

export interface PrivateRouteProps extends  RouteProps {
    path: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ( props: RouteProps ) => {

    // get context
    const context = React.useContext(AppContext);

    // extract children
    const { children, location, ...rest } = props;

    return (
        <CompatRoute 
            {...rest}
            render = { () =>  {
                return context.user.isLoggedIn() ? children : <Redirect to={ { pathname: "/login", state: { from: location } } } />
                }
            }
        />
    );

}

export default PrivateRoute;